import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;

const PostBulkUploadExcelFile = (formData) => {
  return axios
    .post(`${URL}/bulkUploadExcelFile`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message || "Failed to save bulk upload file");
        return { error: true, message: res.message };
      } else {
        return res;
      }
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to save bulk upload file";
      ToastError(message);
      return { error: true, message };
    });
};

const GetBulkUploadExcelFile = (params = {}) => {
  // Build query string from params
  const queryParams = new URLSearchParams();
  if (params.search) {
    queryParams.append('search', params.search);
  }

  const queryString = queryParams.toString();
  const url = queryString
    ? `${URL}/bulkUploadExcelFile?${queryString}`
    : `${URL}/bulkUploadExcelFile`;

  return axios
    .get(url)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
        return { error: true, message: res.message };
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
      return { error: true, message: error.message };
    });
};

const GetBulkUploadExcelFileById = (id) => {
  return axios
    .get(`${URL}/bulkUploadExcelFile/${id}`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
        return { error: true, message: res.message };
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
      return { error: true, message: error.message };
    });
};

const UpdateBulkUploadExcelFileTimestamp = (id) => {
  return axios
    .put(`${URL}/bulkUploadExcelFile/${id}/timestamp`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
        return { error: true, message: res.message };
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
      return { error: true, message: error.message };
    });
};

const GetBulkUploadsWithValidationErrors = () => {
  return axios
    .get(`${URL}/bulkUploadExcelFile/validationErrors`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
        return { error: true, message: res.message };
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
      return { error: true, message: error.message };
    });
};

const MarkValidationErrorsAsFinished = (id, errorIndex) => {
  return axios
    .put(`${URL}/bulkUploadExcelFile/${id}/markFinished`, { errorIndex })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
        return { error: true, message: res.message };
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
      return { error: true, message: error.message };
    });
};

export {
  PostBulkUploadExcelFile,
  GetBulkUploadExcelFile,
  GetBulkUploadExcelFileById,
  UpdateBulkUploadExcelFileTimestamp,
  GetBulkUploadsWithValidationErrors,
  MarkValidationErrorsAsFinished,
};
